// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select__errors .Select__control {	
  border-width: 0.125em;	
  border-color: #d73333;	
}	

.Select__control {	
  font-family: inherit;	
  font-size: inherit;	
  background: white;	
  border-width: 0.063em;	
  border-style: solid;	
  border-color: #edf0f0;	
  border-radius: 0.25em;	
  color: #1f1f1f;	
  height: 3em;	
  padding: 0 2.5em 0 1em;	
  line-height: 1.25em;	
  appearance: none;	
}	

.Select__value-label {	
  line-height: 3em;	
}	

.Select__menu-outer {	
  background-color: #fff;	
  border: 0.063em solid #ebebeb;	
  border-radius: 0.313em;	
  box-shadow: none;	
  margin-top: 0.313em;	
  max-height: none;	
  z-index: 99;	
  overflow: hidden;	
}	

.Select__input {	
  padding: 0;	
}	

.Select__option {	
  background-color: #fff;	
}	

.Select__option.is-focused {	
  background-color: #ecf3fc;	
}	

.Select__menu {	
  max-height: 20em;	
}	

.Select.is-open > .Select__control {	
  border-radius: 0.313em;	
  border-color: #ebebeb;	
}	

.Select__control:hover {	
  box-shadow: none;	
}	

.Select__multi .Select-multi-value-wrapper {	
  height: 3em;	
}	

.Select__multi .Select-value {	
  margin-top: 0.8em;	
}	

.Select__placeholder {	
  line-height: 3em;	
  /* padding: 0 1em;	 */
}	

.Select__multi .Select__input {	
  height: 3em;	
  margin: 0;	
}	

.Select__input > input {	
  line-height: 1em;	
  padding: 0.87em 0;	
}

.Select__indicators {
  display: none;
}`, "",{"version":3,"sources":["webpack://./source/components/InputSelect/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".Select__errors .Select__control {\t\n  border-width: 0.125em;\t\n  border-color: #d73333;\t\n}\t\n\n.Select__control {\t\n  font-family: inherit;\t\n  font-size: inherit;\t\n  background: white;\t\n  border-width: 0.063em;\t\n  border-style: solid;\t\n  border-color: #edf0f0;\t\n  border-radius: 0.25em;\t\n  color: #1f1f1f;\t\n  height: 3em;\t\n  padding: 0 2.5em 0 1em;\t\n  line-height: 1.25em;\t\n  appearance: none;\t\n}\t\n\n.Select__value-label {\t\n  line-height: 3em;\t\n}\t\n\n.Select__menu-outer {\t\n  background-color: #fff;\t\n  border: 0.063em solid #ebebeb;\t\n  border-radius: 0.313em;\t\n  box-shadow: none;\t\n  margin-top: 0.313em;\t\n  max-height: none;\t\n  z-index: 99;\t\n  overflow: hidden;\t\n}\t\n\n.Select__input {\t\n  padding: 0;\t\n}\t\n\n.Select__option {\t\n  background-color: #fff;\t\n}\t\n\n.Select__option.is-focused {\t\n  background-color: #ecf3fc;\t\n}\t\n\n.Select__menu {\t\n  max-height: 20em;\t\n}\t\n\n.Select.is-open > .Select__control {\t\n  border-radius: 0.313em;\t\n  border-color: #ebebeb;\t\n}\t\n\n.Select__control:hover {\t\n  box-shadow: none;\t\n}\t\n\n.Select__multi .Select-multi-value-wrapper {\t\n  height: 3em;\t\n}\t\n\n.Select__multi .Select-value {\t\n  margin-top: 0.8em;\t\n}\t\n\n.Select__placeholder {\t\n  line-height: 3em;\t\n  /* padding: 0 1em;\t */\n}\t\n\n.Select__multi .Select__input {\t\n  height: 3em;\t\n  margin: 0;\t\n}\t\n\n.Select__input > input {\t\n  line-height: 1em;\t\n  padding: 0.87em 0;\t\n}\n\n.Select__indicators {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
